import axios from 'axios'
import {Response} from '../../../../setup/axios/HttpResponse'
import {API_URL} from '../../../utils/common/constants'
import {
  CreatePackageForMajorServiceCentroRequestBody,
  GetBusInfoDetailByCompanyRequestBody,
  GetBusInfoDetailByCompanyResponseData,
  GetListPackageByMajorServiceIdRequestBody,
  PackageWorkflowServiceModel,
  ServiceManagementPackageInfoModel,
  UpdatePackageForMajorServiceCentroRequestBody,
  UpdatePackageStatusForMajorServiceCentroRequestBody,
  updateSameDayBookingRequestBody,
  GetAllServiceGroupRequestBody,
  ServiceGroupQry,
  GetServiceGroupDetailRequestBody,
  SubServiceInfoDTO,
  SaveServiceGroupRequestBody,
  createPackageServiceBundleRequestBody,
  CentroCategoryInfoDetailQry,
  UpdateCentroCategoryInfoRequestBody,
  CentroCategoryListRequest,
  CentroCategoryInfoModel,
  ServiceInfoModel,
  GetSubServiceRequest,
  GetSubSubServiceRequest,
  GetServiceRequest,
  UpdateCentroCategoryStatusRequestBody,
  CentroServiceConfigQry,
  GetCentroServiceConfigRequest,
  SaveCentroServiceConfigRequestBody,
  AddCentroCategoryServiceRequestBody,
  UpdateCentroCategoryServiceRequestBody,
  CentroCategoryServiceQry,
} from '../models'
import {CataloguePayload} from '../components/catalogue-modal/catalogueModel'

const ServiceManagementApi = {
  getListPackageWorkflowService(): Promise<Response<PackageWorkflowServiceModel>> {
    const url = `${API_URL}/api/v1/services/get-package-work-flow-for-centro`
    return axios.get(url)
  },
  createPackageWorkflowService(payload: FormData): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/services/create-package-work-flow-for-centro`
    return axios.post(url, payload, {headers: {'Content-Type': 'multipart/form-data'}})
  },
  updatePackageWorkflowService(payload: FormData): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/services/update-package-work-flow-for-centro`
    return axios.post(url, payload, {headers: {'Content-Type': 'multipart/form-data'}})
  },
  updateSameDayBooking(payload: updateSameDayBookingRequestBody): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/PackageWorkflow/update-same-day-booking`
    return axios.post(url, payload, {headers: {'Content-Type': 'application/json'}})
  },
  getBusInfoDetailByCompany(
    payload: GetBusInfoDetailByCompanyRequestBody
  ): Promise<Response<GetBusInfoDetailByCompanyResponseData>> {
    const url = `${API_URL}/api/v1/services/get-bus-info-detail-by-company${
      payload?.packageId ? `?packageId=${payload.packageId}` : ''
    }`
    return axios.get(url)
  },
  getListPackageByMajorServiceId(
    payload: GetListPackageByMajorServiceIdRequestBody
  ): Promise<Response<ServiceManagementPackageInfoModel[]>> {
    const url = `${API_URL}/api/v1/services/get-package-info-by-major?majorId=${payload.majorId}`
    return axios.get(url)
  },
  createPackageForMajorServiceCentro(
    payload: CreatePackageForMajorServiceCentroRequestBody
  ): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/services/create-new-package-service-for-centro`
    return axios.post(url, payload)
  },
  updatePackageForMajorServiceCentro(
    payload: UpdatePackageForMajorServiceCentroRequestBody
  ): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/services/update-package-service-for-centro`
    return axios.put(url, payload)
  },
  updatePackageStatusForMajorServiceCentro(
    payload: UpdatePackageStatusForMajorServiceCentroRequestBody
  ): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/services/update-package-service-info-status`
    return axios.put(url, payload)
  },
  getDispatchActiveByServiceId(serviceId: any): Promise<Response<any>> {
    const url = `${API_URL}/api/v1/services/get-dispatch-active-by-service-id/${serviceId}`
    return axios.get(url)
  },
  getAllServiceGroup(serviceId: number): Promise<Response<ServiceGroupQry[]>> {
    const url = `${API_URL}/api/v1/service-group/get-all/${serviceId}`
    return axios.get(url)
  },
  getServiceGroupDetail(
    payload: GetServiceGroupDetailRequestBody
  ): Promise<Response<ServiceGroupQry>> {
    const url = `${API_URL}/api/v1/service-group/get-service-group-detail`
    return axios.post(url, payload)
  },
  getSubServiceInfo(serviceId: number): Promise<Response<SubServiceInfoDTO[]>> {
    const url = `${API_URL}/api/v1/service-group/get-sub-service-info/${serviceId}`
    return axios.get(url)
  },
  saveServiceGroup(payload: SaveServiceGroupRequestBody): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/service-group/save`
    return axios.post(url, payload)
  },
  saveAllServiceGroups(payload: SaveServiceGroupRequestBody[]): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/service-group/save`
    return axios.post(url, payload)
  },
  deleteServiceGroup(id: number): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/service-group/${id}`
    return axios.delete(url)
  },
  getPackageServiceInfo(data: any): Promise<Response<any>> {
    const url = `${API_URL}/api/v1/services/get-package-serviceinfo`
    return axios.post(url, data)
  },
  getBundleDataFromPackage(data: any): Promise<Response<any>> {
    const url = `${API_URL}/api/v1/services/get-calculator-bundle`
    return axios.post(url, data)
  },
  createPackageServiceBundle(
    payload: createPackageServiceBundleRequestBody
  ): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/services/create-package-service-bundle`
    return axios.post(url, payload)
  },
  getPackageServiceBundle(payload: any): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/services/get-package-service-bundle`
    return axios.post(url, payload)
  },
  updatePackageServiceBundle(
    payload: createPackageServiceBundleRequestBody
  ): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/services/update-package-service-bundle`
    return axios.put(url, payload)
  },

  /// api for category list
  getCentroCategoryInfoDetail(id: string): Promise<Response<CentroCategoryInfoDetailQry>> {
    const url = `${API_URL}/api/v1/centro-category-info/${id}`
    return axios.get(url)
  },
  addCentroCategoryInfo(payload: FormData): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/centro-category-info/add`
    return axios.post(url, payload, {headers: {'Content-Type': 'multipart/form-data'}})
  },
  updateCentroCategoryInfo(
    payload: UpdateCentroCategoryInfoRequestBody
  ): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/centro-category-info/update/${payload.id}`
    return axios.put(url, payload.body, {headers: {'Content-Type': 'multipart/form-data'}})
  },
  getCategoryList(
    payload: CentroCategoryListRequest
  ): Promise<Response<CentroCategoryInfoModel[]>> {
    const url = `${API_URL}/api/v1/centro-category-info`
    return axios.post(url, payload)
  },
  getServiceByCategoryId(
    payload: GetServiceRequest
  ): Promise<Response<CentroCategoryServiceQry[]>> {
    const url = `${API_URL}/api/v1/centro-category-service`

    return axios.post(url, payload)
  },

  getSubServiceByServiceId(payload: GetSubServiceRequest): Promise<Response<ServiceInfoModel[]>> {
    const url = `${API_URL}/api/v1/centro-category-sub-service`

    return axios.post(url, payload)
  },

  getSubSubServiceBySubServiceId(
    payload: GetSubSubServiceRequest
  ): Promise<Response<ServiceInfoModel[]>> {
    const url = `${API_URL}/api/v1/centro-category-sub-sub-service`

    return axios.post(url, payload)
  },
  updateCentroCategoryStatus(
    payload: UpdateCentroCategoryStatusRequestBody
  ): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/centro-category-info/update-status`
    return axios.put(url, payload)
  },
  updateCentroCategoryServiceStatus(
    payload: UpdateCentroCategoryInfoRequestBody
  ): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/centro-category-service/update-status`
    return axios.put(url, payload)
  },
  getCentroServiceConfig(
    payload: GetCentroServiceConfigRequest
  ): Promise<Response<CentroServiceConfigQry | null>> {
    const url = `${API_URL}/api/v1/centro-category-service/config?serviceLevel=${payload.serviceLevel}&serviceId=${payload.serviceId}&categoryInfoId=${payload.categoryInfoId ?? ''}  `
    return axios.get(url)
  },
  addCentroCategoryService(
    payload: AddCentroCategoryServiceRequestBody
  ): Promise<Response<string | null>> {
    const url = `${API_URL}/api/v1/centro-category-service/add`
    return axios.post(url, payload)
  },
  updateCentroCategoryService(
    payload: UpdateCentroCategoryServiceRequestBody
  ): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/centro-category-service/update/${payload.id}`
    return axios.put(url, payload.body)
  },
  saveCentroServiceConfig(payload: SaveCentroServiceConfigRequestBody): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/centro-category-service/config`
    return axios.put(url, payload)
  },
  uploadCentroCategoryServiceIcon(payload: FormData): Promise<Response<string | null>> {
    const url = `${API_URL}/api/v1/centro-category-service/icon`
    return axios.post(url, payload, {headers: {'Content-Type': 'multipart/form-data'}})
  },
  
  setServiceDefault(): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/set-service-default`;
    return axios.post(url);
  },
  // api for b8ak catalog
  getb8akCatalogue(): Promise<Response<string | null>> {
    const url = `${API_URL}/api/v1/b8ak-catalogue`
    return axios.get(url)
  },
  getB8AKCategoryList(): Promise<Response<string | null>> {
    const url = `${API_URL}/api/v1/b8ak-catalogue/get-b8ak-category`
    return axios.get(url)
  },
  addCategory(params: CataloguePayload): Promise<Response<string | null>> {
    const url = `${API_URL}/api/v1/b8ak-catalogue/save`
    return axios.post(url, params)
  },
}

export {ServiceManagementApi}
